import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import ButtonToggle from '../../ButtonToggle/index'
import { getBoundActions } from '../../../actions/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import { usePostHogEvent } from '../../PostHog/index'

const AIVideoGuideSettings = (props) => {
  const {
    aiVideoGuideHidden,
    staticText,
    setFeatureTrackingDataPersistent,
  } = props

  const trackVideoguideEnabled = usePostHogEvent('aiVideoguideEnabled')
  const trackVideoguideDisabled = usePostHogEvent('aiVideoguideDisabled')

  const onAIVideoGuideSettingsChange = () => {
    // aiVideoGuideHidden is the current state; toggling means the new state is the opposite
    const enablingGuide = aiVideoGuideHidden // currently hidden → enabling

    // Fan-out hooks own both PostHog + GA4 legs for the videoguide toggle.
    if (enablingGuide) {
      trackVideoguideEnabled()
    } else {
      trackVideoguideDisabled()
    }

    setFeatureTrackingDataPersistent({
      data: Map({ aiVideoGuideHidden: !aiVideoGuideHidden }),
    })
  }

  return (
    <div className="my-account-settings-V2__display-settings-controls">
      <div className="my-account-settings-V2__display-settings-text-container">
        <div className="my-account-settings-V2__display-settings-title">
          { staticText.getIn(['data', 'aiVideoGuide']) }
        </div>
        <div className="my-account-settings-V2__display-settings-text">
          {staticText.getIn(['data', 'aiVideoGuideDesc'])}
        </div>
      </div>
      <div className="my-account-settings-V2__display-settings-toggle">
        <ButtonToggle
          checked={!aiVideoGuideHidden}
          onChange={onAIVideoGuideSettingsChange}
          showLabel
          round
        />
      </div>
    </div>
  )
}

AIVideoGuideSettings.propTypes = {
  aiVideoGuideHidden: PropTypes.bool,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
}

export default compose(
  connectRedux(
    (state) => {
      return {
        aiVideoGuideHidden: state.featureTracking.getIn(['data', 'aiVideoGuideHidden'], false),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
      }
    },
  ),
  connectStaticText({ storeKey: 'myAccountSettingsV2' }),
)(AIVideoGuideSettings)
